// extracted by mini-css-extract-plugin
export default {"form_control":"Checkbox_form_control__x3bTV","dark":"Checkbox_dark__kQX4w"};